export default __webpack_public_path__ + "media/ios-dark.bee3c45c.svg";